import { Link } from "react-router-dom";

const neighborhoods = [
  { name: "Brickell", slug: "brickell" },
  { name: "Aventura", slug: "aventura" },
  { name: "Miami Beach", slug: "miami-beach" },
  { name: "Coral Gables", slug: "coral-gables" },
  { name: "Coconut Grove", slug: "coconut-grove" },
  { name: "Doral", slug: "doral" },
  { name: "Kendall", slug: "kendall" },
  { name: "Pinecrest", slug: "pinecrest" },
  { name: "Bay Harbor Islands", slug: "bay-harbor-islands" },
  { name: "Key Biscayne", slug: "key-biscayne" },
  { name: "South Miami", slug: "south-miami" },
  { name: "North Miami Beach", slug: "north-miami-beach" },
];

export default function NeighborhoodCoverage() {
  return (
    <section className="w-full bg-[#fefce8] py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-secondary mb-3">
            Service Across Miami-Dade
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {neighborhoods.map((n) => (
            <Link
              key={n.slug}
              to={`/impact-windows-${n.slug}/`}
              className="flex items-center justify-center px-4 py-2.5 bg-white text-secondary text-sm font-medium rounded-[20px] hover:bg-primary hover:text-white transition-colors whitespace-nowrap shadow-sm"
            >
              {n.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}